
// src/actions/dashboard.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_DASHBOARD_SUMMARY = "FETCH_DASHBOARD_SUMMARY"
export const FETCH_DASHBOARD_SUMMARY_REQUESTED = "FETCH_DASHBOARD_SUMMARY_REQUESTED"
export const FETCH_DASHBOARD_SUMMARY_COMPLETED = "FETCH_DASHBOARD_SUMMARY_COMPLETED"
export const FETCH_DASHBOARD_SUMMARY_FAILED = "FETCH_DASHBOARD_SUMMARY_FAILED"

export function fetchDashboardSummaryRequested() {
  return {
    type: FETCH_DASHBOARD_SUMMARY_REQUESTED
  }
}

export function fetchDashboardSummary(group_id, start_date, end_date) {
  return function(dispatch) {
    dispatch(fetchDashboardSummaryRequested())
    return api.get(`/dashboard/summary/${group_id}`, { start_date, end_date })
        .then((results)=> {
          dispatch(fetchDashboardSummaryCompleted(group_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDashboardSummaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDashboardSummaryCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_SUMMARY_COMPLETED,
    group_id, results,
  }
}

export function fetchDashboardSummaryFailed(error) {
  return {
    type: FETCH_DASHBOARD_SUMMARY_FAILED,
    error,
  }
}

export const FETCH_DASHBOARD_POSTS = "FETCH_DASHBOARD_POSTS"
export const FETCH_DASHBOARD_POSTS_REQUESTED = "FETCH_DASHBOARD_POSTS_REQUESTED"
export const FETCH_DASHBOARD_POSTS_COMPLETED = "FETCH_DASHBOARD_POSTS_COMPLETED"
export const FETCH_DASHBOARD_POSTS_FAILED = "FETCH_DASHBOARD_POSTS_FAILED"

export function fetchDashboardPostsRequested() {
  return {
    type: FETCH_DASHBOARD_POSTS_REQUESTED
  }
}

export function fetchDashboardPosts(group_id, start_date, end_date) {
  return function(dispatch) {
    dispatch(fetchDashboardPostsRequested())
    return api.get(`/dashboard/posts/${group_id}`, { start_date, end_date })
        .then((results)=> {
          dispatch(fetchDashboardPostsCompleted(group_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDashboardPostsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDashboardPostsCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_POSTS_COMPLETED,
    group_id, results,
  }
}

export function fetchDashboardPostsFailed(error) {
  return {
    type: FETCH_DASHBOARD_POSTS_FAILED,
    error,
  }
}

export const FETCH_DASHBOARD_REPLIES = "FETCH_DASHBOARD_REPLIES"
export const FETCH_DASHBOARD_REPLIES_REQUESTED = "FETCH_DASHBOARD_REPLIES_REQUESTED"
export const FETCH_DASHBOARD_REPLIES_COMPLETED = "FETCH_DASHBOARD_REPLIES_COMPLETED"
export const FETCH_DASHBOARD_REPLIES_FAILED = "FETCH_DASHBOARD_REPLIES_FAILED"

export function fetchDashboardRepliesRequested() {
  return {
    type: FETCH_DASHBOARD_REPLIES_REQUESTED
  }
}

export function fetchDashboardReplies(group_id, start_date, end_date) {
  return function(dispatch) {
    dispatch(fetchDashboardRepliesRequested())
    return api.get(`/dashboard/replies/${group_id}`, { start_date, end_date })
        .then((results)=> {
          dispatch(fetchDashboardRepliesCompleted(group_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDashboardRepliesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDashboardRepliesCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_REPLIES_COMPLETED,
    group_id, results,
  }
}

export function fetchDashboardRepliesFailed(error) {
  return {
    type: FETCH_DASHBOARD_REPLIES_FAILED,
    error,
  }
}

export const FETCH_DASHBOARD_RECEIVES = "FETCH_DASHBOARD_RECEIVES"
export const FETCH_DASHBOARD_RECEIVES_REQUESTED = "FETCH_DASHBOARD_RECEIVES_REQUESTED"
export const FETCH_DASHBOARD_RECEIVES_COMPLETED = "FETCH_DASHBOARD_RECEIVES_COMPLETED"
export const FETCH_DASHBOARD_RECEIVES_FAILED = "FETCH_DASHBOARD_RECEIVES_FAILED"

export function fetchDashboardReceivesRequested() {
  return {
    type: FETCH_DASHBOARD_RECEIVES_REQUESTED
  }
}

export function fetchDashboardReceives(group_id, start_date, end_date) {
  return function(dispatch) {
    dispatch(fetchDashboardReceivesRequested())
    return api.get(`/dashboard/receives/${group_id}`, { start_date, end_date })
        .then((results)=> {
          dispatch(fetchDashboardReceivesCompleted(group_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDashboardReceivesFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDashboardReceivesCompleted(group_id, results) {
  return {
    type: FETCH_DASHBOARD_RECEIVES_COMPLETED,
    group_id, results,
  }
}

export function fetchDashboardReceivesFailed(error) {
  return {
    type: FETCH_DASHBOARD_RECEIVES_FAILED,
    error,
  }
}

export const FETCH_DASHBOARD_DETAILS = "FETCH_DASHBOARD_DETAILS"
export const FETCH_DASHBOARD_DETAILS_REQUESTED = "FETCH_DASHBOARD_DETAILS_REQUESTED"
export const FETCH_DASHBOARD_DETAILS_COMPLETED = "FETCH_DASHBOARD_DETAILS_COMPLETED"
export const FETCH_DASHBOARD_DETAILS_FAILED = "FETCH_DASHBOARD_DETAILS_FAILED"

export function fetchDashboardDetailsRequested() {
  return {
    type: FETCH_DASHBOARD_DETAILS_REQUESTED
  }
}

export function fetchDashboardDetails(group_id, user_id, start_date, end_date) {
  return function(dispatch) {
    dispatch(fetchDashboardDetailsRequested())
    return api.get(`/dashboard/details/${group_id}/${user_id}`, { start_date, end_date })
        .then((results)=> {
          dispatch(fetchDashboardDetailsCompleted(group_id, user_id, results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchDashboardDetailsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchDashboardDetailsCompleted(group_id, user_id, results) {
  return {
    type: FETCH_DASHBOARD_DETAILS_COMPLETED,
    group_id, user_id, results,
  }
}

export function fetchDashboardDetailsFailed(error) {
  return {
    type: FETCH_DASHBOARD_DETAILS_FAILED,
    error,
  }
}

export const CLEAR_DASHBOARD_DATA = "CLEAR_DASHBOARD_DATA"
export function clearDashboardData() {
  return {
    type: CLEAR_DASHBOARD_DATA,
  }
}

export const CLEAR_DASHBOARD_DETAILS = "CLEAR_DASHBOARD_DETAILS"
export function clearDashboardDetails() {
  return {
    type: CLEAR_DASHBOARD_DETAILS,
  }
}


// WEBPACK FOOTER //
// ./src/actions/dashboard.js